import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricRoi extends MetricBase {
    constructor() {
        super({
            field: "metric_roas",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.skyscanner.roi.chartName"),
            serieLabel: i18n.t("metrics.skyscanner.roi.serieLabel"),
            tooltip: i18n.t("metrics.skyscanner.roi.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricRoi;
